import Tag from '@/components/atoms/tag'
import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'
import Link from 'next/link'
import { Fragment } from 'react'
import Dates from './dates'
import Title from './title'
import BgHover from './bgHover'

const EventCard = ({ thumbnail, title, categoryName, slug }) => {
  return (
    <Link
      scroll={false}
      href={`/events/${slug.current}`}
      className="relative w-full aspect-[4/5] group"
    >
      <Image
        src={urlForImage(thumbnail.image).url()}
        alt={thumbnail.image.alt}
        fill
        placeholder="blur"
        blurDataURL={thumbnail.image.metadata.lqip}
        className="object-cover"
      />
      <BgHover />
      <div className="absolute top-0 left-0 z-20 w-full h-full p-[15px] md:p-[30px] flex flex-col justify-between">
        <Tag name={categoryName} />
        <div className="relative w-full flex flex-col gap-y-[10px] xl:gap-y-[30px]">
          <Dates date={thumbnail.date} />
          <Title title={title} />
        </div>
      </div>
    </Link>
  )
}

export default EventCard
